import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from '../ApiFetch';
import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardMedia, Divider, Grid } from '@mui/material';
import { LoginInfo } from '../../App';
import FollowButton from '../FollowButton';

const CharacterProfileCard = (props) => {
  // 翻訳
  const {t,i18n} = useTranslation()
  // ログイン情報
  const {loginInfo,setLoginInfo} = useContext(LoginInfo)
  // ナビゲート
  const navigate = useNavigate()
  const location = useLocation()
	const [terms,setTerms] = useState("")

	useEffect(() => {

	},[location.pathname])

    return(
      <Grid xs={12} sm={6} md={5} lg={4} xl={3} xxl={3} className='mb-3'>
        <Card sx={{ maxWidth: props.maxWidth || 300 }} style={{cursor:"pointer",position:"relative"}} onClick={() => {navigate("/character/"+props.data.group_id)}}>
            <CardHeader style={{padding:"0px",position:"absolute",top:"100px",left:"100px",display:"none"}} title={<span style={{fontSize:"16px"}}><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+props.data.user_id+"_s.jpg"} style={{width:"35px",height:"auto",borderRadius:"50%",border:"3px solid #FFFFFF"}} />{props.data.user_name}</span>} />
            <CardHeader style={{padding:"0px",position:"absolute",top:"120px",left:"10px"}} title={<><Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/character/post/t/"+props.data.group_id+"_in.webp"} style={{width:"75px",height:"auto",borderRadius:"10%",border:"5px solid #FFFFFF"}} /></>} />
            <CardHeader style={{padding:"0px",position:"absolute",top:"150px",left:"90px"}} title={<b style={{fontSize:"16px"}}>{props.data.character_name_kana !== "" ? <ruby> {props.data.character_name.substr(0,13)} <rp>(</rp><rt>{props.data.character_name_kana.substr(0,26)}</rt><rp>)</rp> </ruby> : props.data.character_name.substr(0,13)}</b>} />
            <CardMedia component={"img"} image={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/character/post/t/"+props.data.group_id+"_out.webp"} height={150} />
            <CardContent className='mt-4' style={{wordBreak:"break-all",height:"70px",textOverflow:"ellipsis",maxWidth:props.maxWidth || 300}}>
                {props.data.description}<br />
            </CardContent>
            <div style={{padding:"0px",position:"absolute",top:"100px",right:"10px"}} className='d-none'>
              <FollowButton userId={props.data.user_id} follow={props.data.follow} userName={props.data.user_name} />
            </div>
        </Card>
      </Grid>
    )
}

export default CharacterProfileCard;
